import React, { FC } from 'react';
import { COUNTRIES } from '../../constants/locations/countries';
import { TranslatedString, useTranslation } from '../blocks/localization';
import { LabeledSearchableSelect } from '.';

const CountrySelect: FC<CountrySelectProps> = ({ value, onChange, isDisabled, placeholder, error, dataTestId }) => {
    const { t } = useTranslation(['addressForm']);
    const { t: tCountries } = useTranslation(['countries']);

    const options = Object.entries(COUNTRIES).map(([countryCode]) => {
        return { value: countryCode, label: tCountries(`country-${countryCode}`) };
    });

    return (
        <LabeledSearchableSelect
            label={t('country-fieldLabel')}
            value={value}
            onChange={onChange}
            selectOptions={options}
            isDisabled={isDisabled}
            placeholder={placeholder}
            error={error}
            dataTestId={dataTestId}
        />
    );
};

type CountrySelectProps = {
    value: any;
    onChange?(value: string): void;
    isDisabled?: boolean;
    placeholder?: TranslatedString;
    error?: TranslatedString;
    dataTestId?: string;
};

export { CountrySelect };
